import { Grid } from 'antd';

export interface Viewport {
  /** `<576px` — the smallest antd tier (`xs`). */
  isMobile: boolean;
  /** `576px–991px` — `sm`/`md`. */
  isTablet: boolean;
  /** `>=992px` — `lg` and up. */
  isDesktop: boolean;
  /** `true` below `992px`: mobile or tablet. */
  isCompact: boolean;
}

/**
 * Three-tier viewport for layout decisions.
 *
 * antd's `useBreakpoint` reports every tier as a boolean; this collapses them
 * into the three sizes the app reasons about. Keeping the thresholds here (and
 * not inline in each feature) is what stops a page from treating tablet as
 * desktop or as mobile.
 */
export function useViewport(): Viewport {
  const screens = Grid.useBreakpoint();

  const isDesktop = Boolean(screens.lg);
  const isTablet = !isDesktop && Boolean(screens.sm);
  const isMobile = !isDesktop && !isTablet;

  return { isMobile, isTablet, isDesktop, isCompact: !isDesktop };
}
